import React, { useRef, useState } from "react";
import { MainTitle } from "../../pages/styled";
import {
  ContactInput,
  ContactInputLabel,
  ContactWrapper,
  StyledButton,
} from "./styled";
import { ReactComponent as Face } from "../../assets/img/svg/confiansa_feliz.svg";

export default function Contact({ nextStep, setContact, contact }) {
  const [contactLocal, setContactLocal] = useState(contact);
  const nameInputRef = useRef();
  const phoneInputRef = useRef();

  const continueToNext = () => {
    if (
      contactLocal.name &&
      contactLocal.phone &&
      contactLocal.name.length > 3 &&
      /^\d+$/.test(contactLocal.phone) &&
      contactLocal.phone.length > 7
    ) {
      setContact(contactLocal);
      nextStep();
    }
  };

  const handleChange = (e) => {
    const inputValue = e.target.value;
    const newValue = inputValue.replace(/[^a-zA-Z0-9 ]/g, "");
    nameInputRef.current.value = newValue;
    setContactLocal({ ...contactLocal, name: newValue });
  };

  const handleChangeNumbers = (e) => {
    const inputValue = e.target.value;
    const newValue = inputValue.replace(/[^0-9]/g, "");
    phoneInputRef.current.value = newValue;
    setContactLocal({ ...contactLocal, phone: newValue });
  };

  return (
    <>
      <ContactWrapper>
        <Face fill="#00c1d4" style={{ maxHeight: "100px" }} />
      </ContactWrapper>

      <MainTitle
        style={{
          fontWeight: "bold",
          width: "100%",
          marginTop: "-15px",
          marginBottom: "-15px",
        }}
      >
        Queremos conocerte mejor
      </MainTitle>
      <ContactWrapper>
        <ContactInput onChange={handleChange} ref={nameInputRef} />
        <ContactInputLabel>Nombre completo</ContactInputLabel>
        <ContactInput
          onChange={handleChangeNumbers}
          ref={phoneInputRef}
          maxLength={8}
        />
        <ContactInputLabel>Teléfono</ContactInputLabel>
        <StyledButton onClick={() => continueToNext()} noFlex>
          Iniciar el test
        </StyledButton>
      </ContactWrapper>
    </>
  );
}
